import { User } from '../types/User';
import {UserSettings} from "@/types/UserSettings.tsx";
import baseGoApi from "@/api/baseGoApi.ts";

const userApi = {
    getAll: (params: Record<string, any> = {}) => baseGoApi.get<User[]>('/user/', { params }),

    updateProfile: (id: number | string, data: Partial<User>) =>
        baseGoApi.patch<User>(`/user/${id}`, data , {
            headers: {
                "Content-Type": "application/merge-patch+json",
            },
        }),

    delete: (id: number | string) => baseGoApi.delete<void>(`/user/${id}`),

    updateSettings: (id: number | string, settings: Partial<UserSettings>) =>
        baseGoApi.patch<User>(`/user/${id}`, { settings }, {
            headers: {
                "Content-Type": "application/merge-patch+json",
            },
        }),
    generateICal: () => baseGoApi.get<User>(`/user/generate_ical_token`),
    uploadAvatar: (formData: FormData) => {
        return baseGoApi.post(`/user/avatar`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },
    deleteAvatar: () => baseGoApi.delete<User>(`/user/avatar`),
};

export const getCurrentUser = async (): Promise<User> => {
    try {
        const response = await baseGoApi.get(`/user/current`);
        return response.data as User;
    } catch (error: any) {
        console.error(`Error fetching current user:`, error);
        throw new Error(`Error fetching current user`);
    }
};

export const getCoaches = async (): Promise<User[]> => {
    try {
        const response = await baseGoApi.get(`/user/coaches`);
        return response.data as User[];
    } catch (error: any) {
        console.error(`Error fetching current user:`, error);
        throw new Error(`Error fetching current user`);
    }
};

export interface UserLevel {
    id: string;
    name: string;
    description?: string;
    billingType?: 'tick' | 'recurring';
}

export const getUserLevels = async (): Promise<UserLevel[]> => {
    try {
        const response = await baseGoApi.get(`/user/levels`);
        return response.data as UserLevel[];
    } catch (error: any) {
        console.error(`Error fetching user levels:`, error);
        throw new Error(`Error fetching user levels`);
    }
};

export default userApi;
